module.exports = __webpack_public_path__ + "img/jardin14.a2273f27.jpg";